import { render, staticRenderFns } from "./DataTable2.vue?vue&type=template&id=d35525de&scoped=true&"
import script from "./DataTable2.vue?vue&type=script&lang=js&"
export * from "./DataTable2.vue?vue&type=script&lang=js&"
import style0 from "./DataTable2.vue?vue&type=style&index=0&id=d35525de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35525de",
  null
  
)

export default component.exports